<template>
    <bita-modal id="commission-form" :is-loading="isLoadingModal" :modal-lg="true"
        @close="reset()">
        <div slot="body">
            <bita-form ref="commissionForm">
        <div slot="body">
          <div class="row">
            <bita-select
                        label="محصول"
                        ref="products"
                        name="products"
                        rules="required"
                        :validation-container-class="colWidth"
                        :data-source="products"
                        input-class="form-control"
                        data-text-field="name"
                        data-value-field="id"
                        :get-data="getProducts"
                        v-model="myform.product_id"
                        />
<!-- 
                        <bita-select
                  name="commission_type"
                  ref="commission_type"
                  label="نوع کمیسیون"
                  rules="required"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  :data-source="commissionType"
                  data-text-field="title"
                  data-value-field="id"
                  v-model="myform.commission_type"
                /> -->
                <bita-input
             type="text" 
             name="title"
                  ref="title"
                  label="نوع کمیسیون"
              rules="required"
              :validation-container-class="colWidth" 
              input-class="form-control"
              v-model="myform.title" />
            <bita-select
                  name="value_type"
                  ref="value_type"
                  label="نوع هزینه"
                  rules="required"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  :data-source="priceTypes"
                  data-text-field="title"
                  data-value-field="id"
                  v-model="myform.value_type"
                />

                <bita-input
             type="text" 
             name="value" 
             :label="$currencyLabel(' مقدار کمسیون قیمت')"
              :has-thousand-seprator="true" 
              min="0" 
              rules="required"
              v-if="!isPercentage(myform)" 
              :validation-container-class="colWidth" 
              input-class="form-control"
              v-model="myform.value" />

            <bita-input name="value" type="number" label="درصد کمسیون" v-else min="0" max="100" rules="required"
              :validation-container-class="colWidth" input-class="form-control" v-model="myform.value" />
</div>
<bita-bootbutton title="ثبت" type="primary mb-3" icon="fas fa-save" btn-width="150px"
                        @click.native="submit" :disabled="isLoadingModal" />
</div>
</bita-form>
<bita-grid v-if="showGrid" ref="commissionGrid" :columns="gridColumns" :read-data="readData"
                :page-size="pageSize" :has-row-number="true" />

  

        </div>
    </bita-modal>
</template>
<script>
import {
    productApi,
    supplireApi,

} from "@/api/apiManagement";
export default {
    data() {
        return {
            product: [],
            formData: {},
            categories: [],
            colWidth: "col-lg-3",
      colFullWidth: "col-lg-12",
      formData: {},
      myform:{},
      supplire: [],
      products: [],
      filters: {},
      selectValue: 2,
      pageSize: 10,
      isLoadingModal: false,
            showGrid: false,
      priceTypes: [
        { id: 1, title: "درصد" },
        { id: 2, title: "قیمت" },
      ],
      commissionType : [
      { id: 1, title: "محصول" },
        { id: 2, title: "حمل و نقل" },
        { id: 2, title: "مالیات بر ارزش افزوده" },
      ]
        }
    },
    mounted() {
        
    },
    computed: {
        gridColumns() {
            return [
            { title: "نام محصول",template: this.getCommissionProduct},
            { title: "عنوان",template: this.getCommissionTitle},
            { title: "نوع هزینه",template: this.getPriceType},
                { title: "مقدار کمسیون",template: this.getCommissionValue},
                { title: "عملیات", command: this.gridCommands() }
            ]
        }
    },
    methods: {
        setInitialData(_data) {
            console.log(_data)
            this.showGrid = true;
            this.supplire = _data;   
            this.myform.seller_id = this.supplire.id 
            this.getProductsAll();
            },


    getCommissionTitle(e) {
        let commissionTitle = e.title;
        return `${commissionTitle}`;  
    },
    getPriceType(e) {
        let priceType = e.value_type == 1 ? "درصد": "مبلغ";
        return `${priceType}`;  
    },
    getCommissionProduct(e) {
        let commissionProduct = e.product.name ;
      return `${commissionProduct}`;
    },
    getCommissionValue(e) {
        let commissionValue = e.value ;
        return `${commissionValue}`;

    },
        isCategory(selectValue) {
            return selectValue == 2;
        },
        readData(e) {
           
            this.isLoadingModal = true;
            supplireApi.getCommissionOfseller(this.supplire.id)
                .then((res) => {
                    e.success(res.data.entity);
                })
                .catch(() => e.success([]))
                .finally(() => this.isLoadingModal = false);
        },
        loadData() {
            this.$refs.commissionGrid.loadDataSource();
        },
        gridCommands() {
            let commands = [];
            commands.push({
                text: "delete",
                click: this.delete,
                template: this.gridButtons.delete
            });
            return commands;
        },
        isPercentage(myform) {
      return myform.value_type == 1;
    },
    delete(e) {
            let commission = this.$refs.commissionGrid.getSelectedGridRow(e);
            this.$alert("question", `آیا از حذف اطمینان دارید؟`, "", {
                confirmButtonText: "بله",
            }).then((result) => {
                if (result.value) {
                    this.isLoadingModal = true;
                    supplireApi.deleteCommission(commission.id)
                        .then((res) => {
                            this.$izitoast("success", "موفق!", res.data.message);
                            this.loadData();
                        })
                        .finally(() => this.isLoadingModal = false);
                }
            });
        },
        getProducts(e) {
            let filter = {
                search: e.filter?.value
            };
            productApi.getProducts(filter)
                .then((res) => {
                    this.products = _.unionBy(res.data, this.products, "id")
                })
        },
        getProductsAll() {
            /* productApi.getProducts()
                 .then((res) => {
                     this.products = res.data
                     // this.products = _.unionBy(res.data, this.products, "id")
                 })*/
            supplireApi.getProductsOfSeller(this.supplire.id)
                .then((res) => {
                    this.products = res.data.entity
                    // this.products = _.unionBy(res.data, this.products, "id")
                })

        },
       
        submit() {
            this.$refs.commissionForm.validate()
                .then((res) => {
                    if (res) {
                        this.isLoadingModal = true;
                        supplireApi.insertCommissionForSeller(this.myform)
                            .then((res) => {
                                this.$izitoast("success", "موفق!", res.data.message);
                                this.loadData();
                                this.resetSelect();
                            })
                            .finally(() => this.isLoadingModal = false);
                    }
                })
        },
        resetSelect() {
            this.$refs.products.clear();
            this.$refs.myform.clear();
            
            this.$refs.value_type.emptyKendo();

        },
        reset() {
            this.product = {};

            this.showGrid = false;
        }
    }
}
</script>
